/*
 *
 * UploadPage constants
 *
 */

export const STATUS_PENDING = 'pending';
export const STATUS_UPLOADING = 'uploading';
export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'error';
